// extracted by mini-css-extract-plugin
export default {"Grid":"uoALTNTw","Cell":"Jwol7DkO"};